module.exports = new __parcel__URL__("flag-fr.32de41c5.png").toString();